import React from "react";
import GithubContributionGraph from "./GithubContributionGraph";

function Github() {
  return <GithubContributionGraph username="AFA06" />;
}

export default Github;